import React from "react";
import SelectOption from "../../../../components/common/Select/Select";
import Search from "../../../../components/common/Search/Search";
import DateRangePickerNew from "../../../../components/common/DateRangePicker/DateRangePickerNew";
import CustomButton from "components/common/Button/CustomButton";
import { FiDelete } from "react-icons/fi";
import {
  addMonths,
} from "../../../../Utils/utils";
import useCareLabels from "hooks/useCareLabels";
import CareLabelSkeleton from "components/common/CareLabelSkeleton/CareLabelSkeleton";

const FeedbackFilters = ({
  selectedStatus,
  selectedParticipant,
  selectedManager,
  fromDate,
  toDate,
  statusOptions,
  participantOptions,
  managerOptions,
  search,
  setSearch,
  onStatusChange,
  onParticipantChange,
  onManagerChange,
  onDateRangeChange,
  onDateCancel,
  onClearAllFilters,
  loadingParticipants = false,
  loadingManagers = false,
  workersList,
  selectedWorker,
  handleWorkerChange,
  loadingWorkers,
  selectedFromDate,
  setSelectedFromDate,
  participantLabel: participantLabelProp,
  participantLabelPlural: participantLabelPluralProp,
}) => {
  const {
    participantLabel,
    participantLabelPlural,
    isLoading: isCareLabelsLoading,
  } = useCareLabels();

  return (
    <div className='w-full mx-auto flex flex-col'>
      

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mt-3">
        <div className="space-y-1">
          <label className="block text-xs font-medium text-gray-700">Status</label>
          <SelectOption
            isClearable={true}
            newDesign={true}
            data={statusOptions}
            selectedOption={selectedStatus}
            handleChange={onStatusChange}
            placeHolder="Select Status"
            cssClass="w-full"
          />
        </div>

        <div className="space-y-1">
          <label className="block text-xs font-medium text-gray-700">
            {isCareLabelsLoading ? (
              <CareLabelSkeleton width="w-24" height="h-3.5" />
            ) : (
              participantLabel
            )}
          </label>
          <SelectOption
            isClearable={true}
            newDesign={true}
            isDisabled={loadingParticipants || isCareLabelsLoading}
            cssClass="w-full"
            name="participant"
            isSearch={true}
            data={participantOptions}
            selectedOption={selectedParticipant}
            handleChange={onParticipantChange}
            placeHolder={
              isCareLabelsLoading
                ? "Select..."
                : loadingParticipants
                ? `Loading ${participantLabelPlural.toLowerCase()}...`
                : participantOptions.length === 0
                ? `No ${participantLabelPlural.toLowerCase()} available`
                : `Select ${participantLabel}`
            }
            maxHeight="350px"
          />
        </div>

        <div className="space-y-1">
          <label className="block text-xs font-medium text-gray-700">Manager</label>
          <SelectOption
            isClearable={true}
            newDesign={true}
            isDisabled={loadingManagers}
            cssClass="w-full"
            name="manager"
            isSearch={true}
            data={managerOptions}
            selectedOption={selectedManager}
            handleChange={onManagerChange}
            placeHolder={
              loadingManagers
                ? "Loading managers..."
                : managerOptions.length === 0
                ? "No managers available"
                : "Select Manager"
            }
            maxHeight="350px"
          />
        </div>
   <div className="space-y-1">
          <label className="block text-xs font-medium text-gray-700">Worker</label>
          <SelectOption
            isClearable={true}
            newDesign={true}
            isDisabled={loadingWorkers}
            cssClass="w-full"
            name="manager"
            isSearch={true}
            data={workersList}
            selectedOption={selectedWorker}
            handleChange={handleWorkerChange}
            placeHolder={
              loadingWorkers
                ? "Loading workers..."
                : workersList.length === 0
                ? "No worker available"
                : "Select Worker"
            }
            maxHeight="350px"
          />
        </div>
        <div className="space-y-1">
            <label className="block text-xs font-medium text-gray-700">Date Range</label>
          <DateRangePickerNew
            placeholder="Select Date Range"
            showCalendarIcon={true}
            handleCancel={onDateCancel}
            handleChange={onDateRangeChange}
            fromDate={fromDate}
            toDate={toDate}
            setSelectedFromDate={setSelectedFromDate}
            maxDate={addMonths(selectedFromDate, 3)}
          />
        </div>

        <div className="space-y-1">
          <label className="block text-xs font-medium text-gray-700">Search</label>
          <Search
            setSearch={setSearch}
            search={search}
            placeholder="Search feedback..."
            cssClass="text-sm w-full"
            width="w-full"
          />
        </div>
         <div className="space-y-1">
          <label className="block text-xs font-medium text-gray-700"></label>
       
        </div>
  <div className="space-y-1 flex items-end justify-end">
          <label className="block text-xs font-medium text-gray-700"></label>
        <CustomButton
            clickHandler={onClearAllFilters}
                  Icon={<FiDelete />}
            // className='text-sm text-blue-600 hover:text-blue-800 font-medium'
          label="Clear Filter"
          />
        </div>
      </div>
      {/* <div className="flex items-center justify-end mt-2  w-full">
          <CustomButton
            clickHandler={onClearAllFilters}
                  Icon={<FiDelete />}
            // className='text-sm text-blue-600 hover:text-blue-800 font-medium'
          label="Clear Filter"
          />
          

      </div> */}
    </div>
  );
};

export default FeedbackFilters;
